import { Png } from 'common/assets'
import { Config } from 'common/config'

export const slides = [
  {
    img: Png.Libraria,
    // src: Config.General.libraria,
  },
  {
    img: Png.BaboGarden,
    src: Config.General.babogardens,
  },
  {
    img: Png.MonsPins,
    src: Config.General.monspius
  },
  {
    img: Png.Centaur,
    src: Config.General.centaura
  },
]
